module.exports = __webpack_public_path__ + "/images/favicon.6b84cb4.svg";